
import { useLocation, Link } from "react-router-dom";
import { BotMessageSquare, PlusSquare, User, Globe, Compass } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";
import { trackNavigation } from "@/utils/analytics";
import { FlutterUtils } from "@/hooks/useFlutterBridge";
import Hey from "@/lib/hey-utils";

const BottomNav = () => {
  const location = useLocation();
  const isMobile = useIsMobile();
  
  const isActive = (path: string) => location.pathname === path;
  const isAuthPage = location.pathname === "/auth";
  
  // Track navigation click events
  const handleNavClick = (destination: string) => {
    trackNavigation(destination);
    console.debug("🧭 Bottom nav clicked:", destination);
  };
  
  // Don't render the bottom nav in desktop mode or on auth page in mobile mode
  if (!isMobile || (isMobile && isAuthPage) || FlutterUtils.isFlutterWebapp()) {
    return null;
  }
  
  return (
    <>
      {/* Small logo in top-left corner - only show on desktop and non-auth pages */}
      {!isMobile && !isAuthPage && (
        <Link to="/" className="fixed top-4 left-4 z-50">
          <img 
            src={Hey.HeyUtils.getInstance().getConfig().clientLogoUrl}
            alt="Travel App" 
            className="w-10 h-10 rounded-lg shadow-lg"
          />
        </Link>
      )}
      
      <nav className="fixed bottom-0 left-0 right-0 bg-[#000835] border-t border-gray-700 pb-safe z-50">
        <div className="flex justify-around items-center h-16">
          <Link 
            to="/" 
            className={`flex flex-col items-center ${isActive('/') ? 'text-white' : 'text-gray-400'}`}
            onClick={() => handleNavClick("home")}
          >
            <Globe className="w-6 h-6" />
          </Link>
          
          <Link 
            to="/new-trip" 
            className={`flex flex-col items-center ${isActive('/new-trip') ? 'text-white' : 'text-gray-400'}`}
            onClick={() => handleNavClick("new_trip")}
          >
            <PlusSquare className="w-6 h-6" />
          </Link>
          
          <Link 
            to="/discover" 
            className={`flex flex-col items-center ${isActive('/discover') ? 'text-white' : 'text-gray-400'}`}
            onClick={() => handleNavClick("discover")}
          >
            <Compass className="w-6 h-6" />
          </Link>
          
          <Link 
            to="/profile" 
            className={`flex flex-col items-center ${isActive('/profile') ? 'text-white' : 'text-gray-400'}`}
            onClick={() => handleNavClick("profile")}
          >
            <User className="w-6 h-6" />
          </Link>
        </div>
      </nav>
    </>
  );
};

export default BottomNav;
